import { render, staticRenderFns } from "./LabelSelectField.vue?vue&type=template&id=71d18d07&scoped=true&"
import script from "./LabelSelectField.vue?vue&type=script&lang=js&"
export * from "./LabelSelectField.vue?vue&type=script&lang=js&"
import style0 from "./LabelSelectField.vue?vue&type=style&index=0&id=71d18d07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d18d07",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
